var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    enableBackground: "new 0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6,2.5C6.2,2.2,2.5,5.6,2.5,10c0,4.1,3.3,7.4,7.3,7.5c4.3,0.1,7.7-3.3,7.7-7.5C17.5,6.1,14.6,2.9,10.6,2.5z M15.9,9.3 h-2.5c-0.1-1.7-0.5-3.4-1.4-4.9C14.1,5.1,15.7,7,15.9,9.3z M10,4C10,4,10,4,10,4C10,4,10,4,10,4c1.2,1.6,1.8,3.4,1.9,5.3H8.1 C8.2,7.4,8.8,5.6,10,4z M8,4.4C7.1,5.9,6.7,7.6,6.6,9.3H4.1C4.3,7,5.9,5.1,8,4.4z M4.1,10.8h2.6c0.1,1.7,0.7,3.5,1.7,5 C6,15.1,4.4,13.1,4.1,10.8z M8.1,10.8h3.8c-0.2,1.7-0.8,3.4-1.9,4.9C8.9,14.2,8.3,12.5,8.1,10.8z M11.7,15.7c0.9-1.5,1.5-3.3,1.6-5 h2.6C15.6,13.1,14,15.1,11.7,15.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWebsite);
export default __webpack_public_path__ + "static/media/ico-website.732ad7c58eb23f8d93c1072f4475c2e2.svg";
export { ForwardRef as ReactComponent };